import { Helmet } from "react-helmet";

export const Terminos = () => {

  return (
    <div class="container">
      <Helmet>
        <title>Términos y Condiciones | Travel Friends Agencia de Viajes</title>
        <meta name="description" content="Consulta los términos y condiciones de uso de nuestros servicios de viajes. Conoce tus derechos, obligaciones y políticas con Travel Friends.">
        </meta>
      </Helmet>
      <h1>Términos y Condiciones</h1>
      <p>Bienvenido a <strong>Travel Friends</strong>. Al acceder y utilizar nuestro sitio web, aceptas los siguientes términos y condiciones. Por favor, léelos cuidadosamente antes de continuar.</p>

      <h2>1. Uso del sitio</h2>
      <p>El contenido y los servicios ofrecidos en este sitio son exclusivamente para uso personal y no comercial. Está prohibido:</p>
      <ul>
        <li>Modificar, reproducir, distribuir o explotar cualquier contenido del sitio sin autorización previa.</li>
        <li>Usar el sitio para fines ilegales o no autorizados.</li>
      </ul>

      <h2>2. Reservas y pagos</h2>
      <p>Al realizar una reserva en nuestro sitio:</p>
      <ul>
        <li>Debes proporcionar información precisa y completa.</li>
        <li>El pago se realiza a través de plataformas seguras.</li>
        <li>Las tarifas y disponibilidades pueden cambiar sin previo aviso hasta que la reserva esté confirmada.</li>
      </ul>

      <h2>3. Políticas de cancelación</h2>
      <p>Las cancelaciones están sujetas a las políticas de cada proveedor (aerolíneas, hoteles, etc.). Consulta los términos específicos al momento de tu reserva.</p>

      <h2>4. Propiedad intelectual</h2>
      <p>Todo el contenido del sitio (incluyendo textos, imágenes, logotipos y diseños) está protegido por derechos de autor y otras leyes aplicables. No puedes usar este contenido sin nuestra autorización previa por escrito.</p>

      <h2>5. Limitación de responsabilidad</h2>
      <p>No nos hacemos responsables por:</p>
      <ul>
        <li>Errores o inexactitudes en el contenido del sitio.</li>
        <li>Daños o pérdidas resultantes del uso del sitio.</li>
        <li>Retrasos, cancelaciones o problemas relacionados con los servicios de terceros (aerolíneas, hoteles, etc.).</li>
      </ul>

      <h2>6. Enlaces a terceros</h2>
      <p>Este sitio puede contener enlaces a sitios de terceros. No somos responsables por el contenido o las prácticas de privacidad de estos sitios.</p>

      <h2>7. Modificaciones</h2>
      <p>Nos reservamos el derecho de modificar estos términos y condiciones en cualquier momento. Los cambios entrarán en vigor al publicarse en esta página.</p>

      <h2>8. Ley aplicable</h2>
      <p>Estos términos se rigen por las leyes de México. Cualquier disputa se resolverá en los tribunales correspondientes de Ciudad de México.</p>

      <h2>9. Contacto</h2>
      <p>Si tienes preguntas o comentarios sobre estos términos, contáctanos:</p>
      <p><strong>Travel Friends</strong></p>
      <p>Email: <a href="mailto:contacto@travelfriends.com.mx">contacto@travelfriends.com.mx</a></p>
      <p>Teléfono: +52 56 1212 0049</p>


    </div>
  )

}

export default Terminos;